import * as React from "react";

import "./social-dashboard-delete-modal.scss";

import {cs}                    from "@Common/react/chain-services";
import {consumeContext}        from "@Common/react/context";
import {ModalService3}         from "@Common/ui-components/modal-service-3/modal-service-3";
import {IMAGE_SOURCE}          from "../social-dashboard-card";

const TITLE_DELETE_POST = "Delete Post"

export const SocialDashboardDeleteModal = ({post, data, next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Delete Modal",
        width: 360,
        next,
        rootNext,
    })],
    consumeContext('apis'),
    ({modal, apis}) => (
        <div className="social-dashboard-delete-modal-NaOH" xd-qa-type="modal" xd-qa-name="Delete">
            <div className="social-dashboard-delete-header" >
                {TITLE_DELETE_POST}
            </div>
            <div className="social-dashboard-delete-content">
                <div className="social-dashboard-delete-post">
                    <div className="social-dashboard-delete-post-img">
                        <img src={IMAGE_SOURCE[post['shareSite']]} alt={post['shareSite']} />
                    </div>           
                    <div className="social-dashboard-delete-post-message">
                        {post['shareBody']['message']}
                    </div>                    
                </div>
                <div className="social-dashboard-delete-message">
                    {deletePostMessage(post)}
                </div>                
            </div>            
            <div className="social-dashboard-delete-controls">
                <button className="social-dashboard-delete-controls-confirm"
                     onClick={async (e) => {
                        e.stopPropagation()
                        await deletePost(apis, post, data)                        
                        modal.close()
                    }}
                >
                    OK
                </button>
                <button className="social-dashboard-delete-controls-cancel"
                    onClick={(e) => {
                        e.stopPropagation()
                        modal.close()
                    }}
                >
                    Cancel
                </button>                
            </div>
        </div>
    )
)

const deletePostMessage = (post) => {
    return `Delete this post from ${post['shareSite']}?`
}

const deletePost = async (apis, post, data) => {
    let result
    switch(post['shareSite']) {
        case 'Twitter':
            result = await apis.next.social.deletePostTw(post['idPrimary'])
            break
        case 'LinkedIn':
            result = await apis.next.social.deletePostLi(post['idPrimary'])
            break       
        case 'Facebook':
            result = await apis.next.social.deletePostFb(post['idPrimary'])
            break
        case 'Instagram':
        default:                     
            return
    }   
    
    if(result.action == true) {
        await data.reload()        
    }   
}